import { Head, usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { ScreenHeader } from "@/components/ui/headers"
import { SelfInvoiceForm } from "@/features/user/self-invoice-form"
import type { SelfInvoicePrompt } from "@/features/user/types"
import { t } from "@/lib/i18n"

type Props = {
  invoice: SelfInvoicePrompt
  errors: { base?: string[] }
}

/**
 * The self-invoicing portal, reached from the diner's own digital receipt with
 * no account required.
 *
 * It names its own restaurant rather than the current visit's, for the same
 * reason the receipt does: whoever is here paid and left, and may be standing
 * somewhere else entirely.
 */
export default function UserInvoicesShow() {
  const { invoice, errors } = usePage<Props>().props

  return (
    <UserLayout locationName={invoice.locationName}>
      <Head title={t("ui.react.pages.user.invoices.show.title")} />

      <div data-testid="self-invoice-view">
        <ScreenHeader
          title={t("ui.react.pages.user.invoices.show.title")}
          subtitle={t("ui.react.pages.user.invoices.show.subtitle")}
        />
        <SelfInvoiceForm invoice={invoice} errors={errors?.base ?? []} />
      </div>
    </UserLayout>
  )
}
